import { useQuery } from '@tanstack/react-query';

import { $api, errorHandler } from 'modules/global';

import { topicTestsConst } from '..';

export const useFinishTest = ({
  ticketId,
  onClose,
  setOpenResults
}: {
  ticketId?: number;
  onClose?: () => void;
  setOpenResults: (open: boolean) => void;
}) => {
  const { data: finishTest, ...args } = useQuery({
    queryKey: [topicTestsConst.queryKeys.USE_FINISH_TEST, ticketId],
    queryFn: async () => {
      const { data } = await $api.get('/check-test', { params: { ticket_id: ticketId } });

      return data;
    },
    onSuccess: () => {
      if (onClose) {
        onClose();
      }

      setOpenResults(true);
    },
    onError: errorHandler(),
    enabled: !!ticketId
  });

  return { finishTest, ...args };
};
